import { useState } from 'react'
import { Navigate, useLocation, useNavigate } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import './login.css'

function Login() {
  const { isAuthenticated, requiresPasswordReset, login } = useAuth()
  const navigate = useNavigate()
  const location = useLocation()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [isSubmitting, setIsSubmitting] = useState(false)

  if (isAuthenticated) {
    return (
      <Navigate
        to={requiresPasswordReset ? '/reset-password' : '/dashboard'}
        replace
      />
    )
  }

  const handleSubmit = async (event) => {
    event.preventDefault()
    setError('')
    setIsSubmitting(true)
    try {
      const authenticatedUser = await login(email.trim(), password)
      navigate(
        authenticatedUser.requires_password_reset
          ? '/reset-password'
          : location.state?.from?.pathname || '/dashboard',
        {
          replace: true,
        },
      )
    } catch (loginError) {
      setError(loginError.message)
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <main className='login-page'>
      <section className='login-card' aria-labelledby='login-title'>
        <div className='login-card__brand'>
          <span className='login-card__mark'>
            <img src='/logo1.jpg' alt='' />
          </span>
          <span>Buck Press</span>
        </div>
        <div className='login-card__intro'>
          <span className='app-content__eyebrow'>Workspace access</span>
          <h1 id='login-title'>Welcome back.</h1>
          <p>Sign in to manage your publishing workspace.</p>
        </div>
        <form className='login-form' onSubmit={handleSubmit}>
          <label>
            Email address
            <input
              type='email'
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              placeholder='you@buckpress.com'
              autoComplete='email'
              required
            />
          </label>
          <label>
            Password
            <input
              type='password'
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              placeholder='Enter your password'
              autoComplete='current-password'
              required
            />
          </label>
          {error && (
            <p className='login-form__error' role='alert'>
              {error}
            </p>
          )}
          <button type='submit' disabled={isSubmitting}>
            {isSubmitting ? 'Signing in...' : 'Sign in'}{' '}
            <span aria-hidden='true'>→</span>
          </button>
        </form>
        <p className='login-card__footer'>
          Buck Press Limited · Publishing workspace
        </p>
      </section>
    </main>
  )
}

export default Login
